// PowerBICollapsible.tsx
import React from "react";
import { Accordion } from "@mantine/core";
import PowerBIHelpSection from "./PowerBIHelpSection";

const PowerBICollapsible: React.FC<{ url: string; defaultOpened?: boolean }> = ({ url, defaultOpened = false }) => {
  return (
    <Accordion chevronPosition="right" multiple={false} defaultValue={defaultOpened ? "pbi" : undefined} variant="separated">
      <Accordion.Item value="pbi">
        <Accordion.Control icon={<i className="fa fa-plug" />}>
          Power BI – enkelt oppsett
        </Accordion.Control>
        <Accordion.Panel>
          <PowerBIHelpSection url={url} />
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default PowerBICollapsible;
